module.exports = __webpack_public_path__ + "img/20200904_140324.95603994.jpg";